export const inboxFilterKey = "inbox:filter";
export const inboxBadgeKey = "inbox:badge";
